// import react from "react";
import '../Styles/About.css';
import { useEffect, useState } from "react";
import axios from 'axios';
import LangChange from './LangChange';
export default function AboutUs() {
    // const {t} = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("lang"));
    const [about, setAbout] = useState({});
    const getAboutEnglishData = async () => {
        // axios.post('http://localhost:3001/about/ar')
        //     .then(res => {
        //        console.log('Arabic response', res.data);
        //     }).catch(error => {
        //         console.error('Error fetching data:', error.message);
        //     });
        axios.get('https://n2m4hmwxiw.us-east-1.awsapprunner.com/about')
            .then(res => {
                setAbout(res.data.message);
            }).catch(error => {
                console.error('Error fetching data:', error.message);
            });
    }
    const getAboutArabicData = async () => {
        
        axios.get('https://n2m4hmwxiw.us-east-1.awsapprunner.com/about/ar')
            .then(res => {
                setAbout(res.data.message);
                // console.log('Arabic response', res.data);
            }).catch(error => {
                console.error('Error fetching data:', error.message);
            });
    }
    useEffect(() => {
        setCurrentLanguage(localStorage.getItem("lang"));
        if (currentLanguage === "en") {
            getAboutEnglishData();
        } else {
            getAboutArabicData();
        }


    }, [currentLanguage]);
    useEffect(() => {
        setCurrentLanguage(localStorage.getItem("lang"));
        if (currentLanguage === "en") {
            getAboutEnglishData();
        } else {
            getAboutArabicData();
        }
    }, [localStorage.getItem("lang")]);
    const dynamicStyle = {
        'textAlign': localStorage.getItem("lang") === "ar" ? 'right' : 'left',
        'listStyleType': localStorage.getItem("lang") === "ar" ? 'none' : null
    }
    return (
        <div>
            <LangChange />
            {
                about.length > 0 && about.map((item, index) => (
                    <div key={index} className='divData'>
                        <h3 style={dynamicStyle}>{item.Name}</h3>
                        <p style={dynamicStyle} >{
                            item?.Info ?
                                item?.Info.split(".").map((temp, index) => (
                                    <li style={dynamicStyle} key={index}>{temp}</li>))
                                : item?.Info
                        }</p>
                    </div>
                ))
            }
        </div>)
}